var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvenueFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 303.81 89.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 57.66,
    x2: 68.09,
    y2: 57.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9a83b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd584"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 14.14,
    y1: 45.64,
    x2: 50.49,
    y2: 45.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5d994"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bfe3e2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 13.44,
    y1: 17.22,
    x2: 59.86,
    y2: 63.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#fdd789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#f6d68c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#f5d68d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#f1d590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#e5d398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#d1d0a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8bc4cd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "148.59 64.79 162.45 31.79 153.48 31.79 145.12 52.91 136.71 31.79 127.52 31.79 141.38 64.79 148.59 64.79 148.59 64.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "115.01 31.79 128.87 64.79 119.91 64.79 111.55 43.67 103.13 64.79 93.95 64.79 107.81 31.79 115.01 31.79 115.01 31.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "192.46 64.79 192.46 58.08 178.44 58.08 178.44 50.71 189.71 50.71 189.71 44.06 178.44 44.06 178.44 38.5 192.46 38.5 192.46 31.79 169.53 31.79 169.53 64.79 192.46 64.79 192.46 64.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "209.6 64.79 209.6 45.82 224.56 64.79 231.33 64.79 231.33 31.79 223.46 31.79 223.46 50.77 208.5 31.79 201.74 31.79 201.74 64.79 209.6 64.79 209.6 64.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256.6,65.73c8.91,0,15.95-5,15.95-16.17V31.79H263.8V49.06c0,5.83-2.31,9-7.09,9s-7-3.14-7-9V31.79h-9V49.56c0,11.16,7.09,16.17,16,16.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "303.81 64.79 303.81 58.08 289.78 58.08 289.78 50.71 301.06 50.71 301.06 44.06 289.78 44.06 289.78 38.5 303.81 38.5 303.81 31.79 280.87 31.79 280.87 64.79 303.81 64.79 303.81 64.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8,29.73A3.91,3.91,0,0,0,4,25.84a3.92,3.92,0,0,0-4,3.86v.77C0,34.88,0,39.38,0,43.84c0,3.84.06,7,.13,9.93,0,1.9.09,3.49.17,5S.47,62,.7,64a38.08,38.08,0,0,0,2.15,8.51,26.43,26.43,0,0,0,4.83,7.84,24.2,24.2,0,0,0,7.52,5.58,34.28,34.28,0,0,0,8.62,2.77,55.83,55.83,0,0,0,9.21.78,41.86,41.86,0,0,0,6.83-.57,32.24,32.24,0,0,0,6.77-2,26.85,26.85,0,0,0,11-8.75,44.08,44.08,0,0,0,6-11.74c.64-1.77,1.2-3.56,1.74-5.28.67-2.14,1.31-4.16,2-6l.28-.65,0,0a3.85,3.85,0,0,0-2-5.11,4,4,0,0,0-5.23,2h0l-.39.93c-.95,2.39-1.65,4.64-2.34,6.83-.51,1.65-1,3.21-1.56,4.75a36.31,36.31,0,0,1-4.9,9.71,18.81,18.81,0,0,1-7.82,6.22,27.07,27.07,0,0,1-10.41,1.88,47.41,47.41,0,0,1-7.77-.65c-5.16-1-9.09-3-11.67-5.88a18.69,18.69,0,0,1-3.36-5.49,30.15,30.15,0,0,1-1.67-6.65v0c-.15-1.31-.26-2.86-.33-4.59-.07-1.43-.12-3-.16-4.83C8,50.68,8,47.57,8,43.8c0-4.39,0-8.85,0-13.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M50.49,14a4.1,4.1,0,0,0-8.2,0V58.48c0,2.51,0,5-.11,7.35a26.6,26.6,0,0,1-.91,6.46L41,73l-.11.34-.15.27-.28.56c-.1.18-.23.3-.33.46a4.5,4.5,0,0,1-.72.78c-.1.15-.3.2-.43.31a5.4,5.4,0,0,1-.47.3A13.52,13.52,0,0,1,32.75,77h0A13.63,13.63,0,0,1,27,75.93a6.43,6.43,0,0,1-3.13-3.67,22.32,22.32,0,0,1-1.29-6.39c-.2-2.36-.23-4.86-.24-7.39V10.23a4.1,4.1,0,0,0-8.19,0V58.48c0,2.62,0,5.28.26,8.05a29.92,29.92,0,0,0,1.85,8.7c.16.38.29.75.48,1.13l.62,1.12a14.75,14.75,0,0,0,1.53,2.17,18.75,18.75,0,0,0,2,1.91l1.14.77a6.65,6.65,0,0,0,1.17.69,21.59,21.59,0,0,0,9.57,2h0a21.44,21.44,0,0,0,9.68-2,10.44,10.44,0,0,0,1.21-.75,7.94,7.94,0,0,0,1.15-.85,12,12,0,0,0,2-2.1,12.34,12.34,0,0,0,.8-1.14L48.17,77l.29-.6.22-.58.42-1.18a33.44,33.44,0,0,0,1.27-8.43c.12-2.65.11-5.21.12-7.73V14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M67.34,55.42a4.08,4.08,0,0,0-6.61-4.8v0l-.56.7-.38.49a35.93,35.93,0,0,1-2.56,2.94,31.63,31.63,0,0,1-2.89,2.54,28.75,28.75,0,0,1-6.57,3.93,34.17,34.17,0,0,1-7.44,2.22c-.65.12-1.3.19-1.95.3l-1.76.18h-.19V4.08a4.09,4.09,0,0,0-8.17,0V68.13h0v.08a4,4,0,0,0,4.08,4h0A46.13,46.13,0,0,0,51,68.69a37,37,0,0,0,8.37-5A41.19,41.19,0,0,0,63,60.47a43.83,43.83,0,0,0,3.18-3.64l.47-.6.68-.87"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvenueFooter);
export default __webpack_public_path__ + "static/media/avenue-footer.18d7cb258e693346f472ac5597cb8c06.svg";
export { ForwardRef as ReactComponent };